// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1aR8eJEEsJUI6VfkYbmKvw","tableWrapper":"_2LKnYSmr6gh9nzMoIuzYfK","tableWrapperResponsive":"eMtKbrjNLrX05jeDlA3av"};